import { InstallationProvider } from '../InstallationProvider';
import { LocationOptionsData, SubmissionDataTabsDefinition } from 'types/types.type';
import { PropertyColumn, SubmissionDetails } from 'types/submission.type';
import { DataGridColumn } from 'components/Sov/components/SovEditGrid/components/DataGrid';
import { ColDef, ColGroupDef } from 'ag-grid-enterprise';
import { getSOVEditColumns } from './SOVEditGridDefs';
import { getSovColumnDefs } from './SOVGridDefs';
import { ComponentType } from 'react';
import { RouteComponentProps } from 'react-router';
import { WithStyles } from '@mui/styles';
import AddressBR from 'views/SubmissionDetails/components/Address/AddressBR';
import { SubmissionURL } from 'services/config';
import { BRValuesSection } from 'components/LrProducerDashboard/components/LocationMap/components/LocationValuesSection';
import { MapLocation } from 'types/location.type';
import Location from 'application/Models/Location';
import { ReportingTab } from 'types/reporting.type';
import { getReportingTabs } from 'helpers/permissions/BrReporting';
import { NavLink } from 'types/nav.types';
import { getNavLinks, getConfigNavLinks } from 'helpers/permissions';
import { brNavLinksConfig } from 'helpers/permissions/BrNavLinks';
import { brNavActionsConfig } from 'helpers/permissions/BrActions';
import { Theme } from '@mui/material';
import { brBaseColumnDefs } from 'views/Submissions/components/BrSubmissionColumnDefs';
import { getBrSubmissionTabDefinition } from 'views/Submissions/components/BrSubmissionListDefs';
import BrUWGuidelinesInfo from 'components/SideNav/components/BrUWGuidelinesInfo';
import React from 'react';
import AdjustmentBRReview from 'views/SubmissionDetails/components/UnderwriterReview/components/BuildersRisk/AdjustmentBRReview';
import { AdjustmentReviewProps } from 'views/SubmissionDetails/components/UnderwriterReview';
import { BRLrProducerDashboard, ProducerDashboardProps } from 'components/LrProducerDashboard';
import { BR_EXTENSION_CONFIRM_DIALOG_COPY } from 'constants/copy';
import { extendPolicyWithDateSchema } from 'views/SubmissionDetails/components/EndorsementDialogs/components/ValidationSchema';

export class BRInstallationProvider implements InstallationProvider {
    getProducerDashboardComponenet(): ComponentType<ProducerDashboardProps> {
        return BRLrProducerDashboard;
    }
    getDoesAllowTRIADecline(): boolean {
        return true;
    }

    getSovEditGridDef(
        locationOptions: LocationOptionsData,
        disabledColumns?: PropertyColumn[]
    ): Record<PropertyColumn, DataGridColumn> {
        return getSOVEditColumns(locationOptions, disabledColumns);
    }

    getSovGridDef(
        submission: SubmissionDetails,
        isAgent: boolean,
        locationOptions: LocationOptionsData
    ): (ColDef | ColGroupDef)[] {
        return getSovColumnDefs(submission, isAgent, locationOptions);
    }

    canEditDirectory(): boolean {
        return false;
    }

    getLocationReviewComponent(): ComponentType<
        RouteComponentProps<{ id: string; locationId: string }> & WithStyles<any>
    > {
        return AddressBR;
    }

    getLocationAccumulationsSummaryUrl(submissionId: string, locationIds: number[]): string {
        return `${SubmissionURL}/br/submission/${submissionId}/accumulation-summary?locationIds=${locationIds.join(
            ','
        )}`;
    }

    getUnderwritingTrendUrl(submissionId: string, locationId: number): string {
        return `${SubmissionURL}/br/submission/${submissionId}/zone-underwriting-trend?locationId=${locationId}`;
    }

    getReportingTabs(group: string): ReportingTab[] {
        return getReportingTabs(group);
    }

    getNavLinks(group: string): NavLink[] {
        return getNavLinks(brNavLinksConfig, group);
    }

    getConfigNavLinks(group: string): NavLink[] {
        return getConfigNavLinks(brNavLinksConfig, group);
    }

    getActionsConfig() {
        return brNavActionsConfig;
    }

    getSubmissionListColumnDefs(theme: Theme): any[] {
        return brBaseColumnDefs(theme);
    }

    getSubmissionTabDefinition(userGroup: string): SubmissionDataTabsDefinition {
        return getBrSubmissionTabDefinition(userGroup);
    }

    getUwGuidelinesMenuItems() {
        return <BrUWGuidelinesInfo />;
    }

    getLocationValuesComponent(): ComponentType<{ locationData: MapLocation | Location }> {
        return BRValuesSection;
    }

    getIssuanceChecklist(): string[] {
        return ['Confirm Signed TRIA form is present if TRIA coverage was declined.'];
    }

    getAdjustmentReviewScreen(props: AdjustmentReviewProps, productType?: string) {
        return <AdjustmentBRReview {...props} />;
    }

    getPrimaryProductLineCode(): string {
        return 'BUILDERS_RISK';
    }

    getExtensionDialogCopy(namedInsured?: string, expirationDate?: string): string {
        return BR_EXTENSION_CONFIRM_DIALOG_COPY(namedInsured, expirationDate);
    }

    getExtensionValidationSchema(expirationDate: string) {
        return extendPolicyWithDateSchema(expirationDate);
    }

    usesDateExtension(): boolean {
        return true;
    }

    showCountOnMapCluster(productLineCode: string): boolean {
        return false;
    }
}
